<div class="char-block">
  <div class="char-block__head">
    <h2 class="title">
      {{ "ANALYTICS_PAGE.PAYMENT_PAGE" | translate }}
    </h2>

    <div class="select-block">
      <div class="desc">
        {{ "ANALYTICS_PAGE.FROM" | translate }}
      </div>
      <div
        (click)="openMonthList($event)"
        [class.active]="isOpenMonthSelect"
        class="input-block select month">
        <input
          [readonly]="true"
          id="merchantsList"
          class="input"
          type="text"
          value=" {{ selectedMonth?.fieldName }}" />
        <ul class="select__list">
          <li
            *ngFor="let item of monthList"
            (click)="setMonth($event, item)"
            class="select__list-item">
            <div class="merchant-item">
              <span>{{ item.fieldName }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div
        (click)="openYearList($event)"
        [class.active]="isOpenYearSelect"
        class="input-block select year">
        <input
          [readonly]="true"
          id="merchantsList"
          class="input"
          type="text"
          value=" {{ selectedYear }}" />
        <ul class="select__list">
          <li
            *ngFor="let item of yearList"
            (click)="setYear($event, item)"
            class="select__list-item">
            <div class="merchant-item">
              <span>{{ item }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <hr />

  <ng-container *ngIf="isDataValid; else emptyData">
    <div class="legend">
      <div class="crossings">
        <span class="round">
          {{ "ANALYTICS_PAGE.TOTAL_CROSSINGS" | translate }}
        </span>
        <span class="value">{{ totalHits }}</span>
      </div>
      <div class="payments">
        <span class="round">
          {{ "ANALYTICS_PAGE.TOTAL_PAYMENTS" | translate }}
        </span>
        <span class="value">{{ totalSuccessfulTransactions }}</span>
      </div>
    </div>
  </ng-container>

  <div
    [class.hidden]="!isDataValid"
    class="char-block__canvas"
    style="width: calc(100% - 10px); height: 250px">
    <canvas id="return-page"></canvas>
  </div>
</div>

<ng-template #emptyData>
  <div class="char-block__empty">
    <h2 class="char-block__empty-title">
      {{ "ANALYTICS_PAGE.EMPTY_DATA" | translate }}
    </h2>

    <p class="char-block__empty-description">
      {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_HEADER_PAYMENT_PAGE" | translate }}
      <a routerLink="/support"> {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_SUPPROT" | translate }}</a>
    </p>
  </div>
</ng-template>
